import React from 'react';
import { BrowserRouter as Router , Route } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css" ;


//import Login from '../components/SiginIn';
import Ind from '../component/navbar'
import CV from '../component/PDF'
 //import Admin  from '../components/App'
 
/*
          <Route exact path="/login" render={props => <Login {...props} />} />
          <Route exact path="/Admin" render={props => <Admin {...props} />} />
          */

function App(){
    return(
       
        <Router>
      
         
          <Route exact path="/" render={props => <Ind {...props} />} />
         
          <Route exact path="/CV" render={props => <CV {...props} />} />

          
        </Router>   

         
    );
}

export default  App;
